import { render } from "./LivePreview.vue?vue&type=template&id=3d573cd7&scoped=true"
import script from "./LivePreview.vue?vue&type=script&lang=js"
export * from "./LivePreview.vue?vue&type=script&lang=js"

import "./LivePreview.vue?vue&type=style&index=0&id=3d573cd7&lang=scss&scoped=true"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d573cd7"]])

export default __exports__